module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/vertical-4ce3f3b886df62caf1e91bd216032c72.svg";